import { getRequestProps } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { stringifyUrl } from "query-string";
export function TournamentsRequestFormatter(message) {
    let { baseUrl, endpoint, method, headers, body, params } = getRequestProps(ConnectionNames.tournaments, message);
    headers["Content-Type"] = "application/json; charset=utf-8";
    const query = stringifyUrl({
        url: `${baseUrl}${endpoint}`,
        query: params
    }, {
        skipNull: true,
        sort: false
    });
    return new Request(query, {
        method,
        headers,
        body
    });
}
//# sourceMappingURL=TournamentsRequestFormatter.js.map